/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_PassInputs */

const en_rd_pass = /** @type {(inputs: Rd_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pass`)
};

const id_rd_pass = /** @type {(inputs: Rd_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lolos`)
};

/**
* | output |
* | --- |
* | "Pass" |
*
* @param {Rd_PassInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_pass = /** @type {((inputs?: Rd_PassInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_PassInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_pass(inputs)
	return en_rd_pass(inputs)
});